import { File as GQLFile } from '../../generated/graphql';
import { MessageExpandableTagList, MessageExpandableTagListProps } from './MessageExpandableTagList';
import { Tag } from './Tag';
import { useTranslation } from 'react-i18next';

interface AdvisorCreateMessageExpandableTagListProps {
  messageExpandableTagListProps: Omit<MessageExpandableTagListProps, 'tagItemRenderer'>;
  clickHandlers: {
    onRemovePendingFile: (file: GQLFile) => void;
    onRemoveOnboardingReminder: () => void;
  };
}

export function AdvisorCreateMessageExpandableTagList({
  clickHandlers,
  messageExpandableTagListProps,
}: AdvisorCreateMessageExpandableTagListProps) {
  const { t: tMessaging } = useTranslation('inAppMessaging');

  return (
    <MessageExpandableTagList
      {...messageExpandableTagListProps}
      tagItemRenderer={({ file, onboardingReminder }) => (
        <>
          {onboardingReminder && (
            <Tag.Item
              allowRemove
              icon="rocketLaunch"
              key="onboardingReminder"
              label={tMessaging('general-onboarding-reminder')}
              onRemove={clickHandlers.onRemoveOnboardingReminder}
              motionProps={{
                layoutId: 'onboardingReminder',
                layout: messageExpandableTagListProps.disableAnimation ? 'position' : undefined,
              }}
            />
          )}
          {file && (
            <Tag.Item
              allowRemove
              key={file.id}
              icon="document"
              label={file.name}
              onRemove={() => clickHandlers.onRemovePendingFile(file)}
              motionProps={{
                layoutId: file.id,
                layout: messageExpandableTagListProps.disableAnimation ? 'position' : undefined,
              }}
            />
          )}
        </>
      )}
    />
  );
}
